<h1>{{ 'profile.paymentAccount' | translate }}</h1>
<router-outlet></router-outlet>
